// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__r-tO0","rotation":"Loader_rotation__mTy3g"};